import { FormGroup } from "@angular/forms";
import { environment } from "src/environments/environment";

export  class  Tools {

    public static isValidImageType(file: File): boolean {
        const allowedExtensions = new Set(['.jpg', '.jpeg', '.svg', '.png']);
    
        const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
    
        return allowedExtensions.has(extension);
    }


    public static logFormErrors(form: FormGroup): void {
        if(environment.production){
            return;
        }

        Object.keys(form.controls).forEach(key => {
          const controlErrors = form.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(errorKey => {
              console.log('Key control: ' + key + ', error: ' + errorKey + ', value: ', controlErrors[errorKey]);
            });
          }
        });
      }


      public static deepCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
      }
    
    
    
      public  static isFormValidAllowingOneSpecificInvalid(form:FormGroup, invalidControlName: string): boolean {
        let invalidCount = 0;
        Object.keys(form.controls).forEach(key => {
          const control = form.get(key);
          if (control && control.invalid && key !== invalidControlName) {
            invalidCount++;
          }
          if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach(subKey => {
              const subControl = control.get(subKey);
              if (subControl && subControl.invalid && `${key}.${subKey}` !== invalidControlName) {
                invalidCount++;
              }
            });
          }
        });
        return invalidCount === 0;
      }
    

}
